<template>
    <div class="logout"></div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    data() {
        return {};
    },
    components: {},
    methods: {
        ...mapActions(['clearAllData'])
    },
    computed: {},
    created() {
        this.$api.logout().then(() => {
            this.clearAllData().then(() => {
                this.$router.push('/login');
            });
        });
    }
};
</script>
